import * as Sentry from '@sentry/react';
import amplitude from 'amplitude-js';
import memoize from 'lodash/memoize';

const init = memoize(() => {
    const apiKey = process.env.REACT_APP_DATE_API_KEY || "";

    amplitude.getInstance().init(apiKey, undefined, {
        includeReferrer: true,
        disableCookies: true,
    })
})


export const trackEvent = (eventName: string, data?: Record<string, any>) => {
    if(process.env.NODE_ENV !== 'production') return;

    init();

    amplitude.getInstance().logEvent(eventName, data);
}

export const setUserForTracking = (userId: string, name?: string) => {
    if (process.env.NODE_ENV !== 'production') return;

    Sentry.configureScope((scope:any) => {
        scope.setUser({ userId })
    })

    init();

    amplitude.getInstance().setUserId(userId);
    amplitude.getInstance().setUserProperties({ name });
}